var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_container"},[_c('pulse-loader',{attrs:{"loading":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }